import React, { useEffect, useState } from 'react'
import Header from '../adminComponents/header/Header'
import { Box, Grid, Typography } from '@mui/material'
import { getItemsByID } from '../services/OurCategories'
import ImageSlider from '../components/product/ImageSlider'
import { useMediaQueries } from '../usecontext/UseProvider'
import { useParams } from 'react-router-dom'
const ViewProduct = () => {
  const [productData, setProductData] = useState([])
  const { id } = useParams()
  const { isSmallScreen, isMediumScreen, isLargeScreen } = useMediaQueries();

  const getProductData = async () => {
    try {
      const response = await getItemsByID(id);
      setProductData(response?.categoryItemData);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getProductData();
  }, []);


  const details = [
    { label: "Category", value: productData?.createdBy?.name },
    {
      label: "Tags",
      value: productData?.tags?.join(", ") || "",
    },
    {
      label: "Size",
      value: `Length: ${productData?.length},  Width: ${productData?.width},    Height: ${productData?.height}`,
    },
    {
      label: "Material",
      value: productData?.material,
    },
  ];

  const descriptionData = [
    { title: "Warranty", content: productData?.warranty },
    { title: "Hanging Set", content: productData?.hangingSet },
    { title: "Cushion", content: productData?.cushion },
    {
      title: "Maintenance",
      content: (
        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          {productData?.maintenance?.map((item, index) => (
            <li key={`${item}-${index}`}>{item}</li> // Ensure unique key
          ))}
        </ul>
      )
    },
    { title: "Customization Available", content: productData?.customizationAvailable },
    {
      title: 'Additional Information',
      content: (
        productData?.additionalInformation?.length > 0 ? (
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            {productData.additionalInformation.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        ) : (
          <Typography variant="body1" sx={{ color: 'gray' }}>
            No additional information available.
          </Typography>
        )
      )
    }
  ];


  return (
    <>
      <Header title="Product" />
      <Box sx={{ mt: 3, p: { lg: 2 } }}>
        <Grid container spacing={3} alignItems="center">
          {/* Left Section - Image */}
          <Grid item xs={12} lg={6} textAlign={"center"} >
            <ImageSlider images={productData?.images || []} />
          </Grid>

          {/* Right Section - Content */}
          <Grid item xs={12} lg={6} >
            <Typography
              variant={isSmallScreen ? 'h5' : 'h4'}
              sx={{ fontWeight: "bold", marginBottom: 3 }}
            >
              {productData?.name}
            </Typography>
            <Typography
              variant={"body2"}
              sx={{
                fontSize: { lg: '20px', md: '18px', xs: '16px' },
              }}
            >
              {productData?.description}
            </Typography>

            <Box sx={{ lineHeight: 1.6, mt: { lg: 4, xs: 2 } }}>
              <Grid container spacing={3}>
                {/* Column for labels */}
                {details?.map((detail, index) => (
                  <React.Fragment key={`${index}-${detail.label}`}>
                    <Grid item xs={3}>
                      <Typography
                        variant={isSmallScreen ? "body1" : "h6"}
                        fontWeight="bold"
                      >
                        {detail.label}
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography
                        variant={isSmallScreen ? "body2" : "body1"}
                      >
                        {detail.value}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} mt={3}>
          {descriptionData.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={3} >
                <Typography
                  variant={isSmallScreen ? 'body1' : 'h6'}
                  sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word' }}
                >
                  {item.title}
                </Typography>
              </Grid>
              <Grid item xs={9} >
                <Box variant="body1">
                  {item.content}
                </Box>
              </Grid>
            </ React.Fragment>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default ViewProduct
